import { computed, ref } from 'vue'
import { defineStore } from 'pinia'

export const useEvidenciaStore = defineStore('evidencia', () => {
  const evidencias = ref([])
  const evidencia = ref({})
  /** @type {import('vue').Ref<import('../types/pergunta').ResultAgrupamentoEnvioEvidencia[]>} */
  const agrupamentoEnvio = ref([])
  const agrupamentoPeriodo = ref([])

  const modalEvidenciaCreateRef = ref(null)
  const modalEvidenciaRef = ref(null)

  const filesData = computed(
    () => evidencia.value?.evidenciafile_set || []
  )

  const loading = ref({
    getEvidencia: true,
    getAnteriores: true,
    evidencia: {
      enviando: false,
      porcentagem: 0,
    },
  })
  return {
    evidencia,
    filesData,
    evidencias,
    loading,
    modalEvidenciaCreateRef,
    modalEvidenciaRef,
    agrupamentoEnvio,
    agrupamentoPeriodo,
  }
})
